import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { LoftDigit } from '../../api/models';

export type TABLE_TYPE = Table<LoftDigit>;

export const TABLE = 'loftDigit';
const SCHEMA = 'loftDigitId, headTypeId, sortId'; // headTypeId index for quick lookups

class LoftDigitDatabase implements DataRepository<LoftDigit> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<LoftDigit | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: LoftDigit, key: Key): Promise<LoftDigit> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: LoftDigit[]): Promise<LoftDigit[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<LoftDigit[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const LoftDigitDB = new LoftDigitDatabase(db);
